<script setup lang="ts">
import type { EventNameDetails } from "~/types/Event";

type Props = {
  event: EventNameDetails;
  divider?: boolean;
  direction?: "horizontal" | "vertical";
};

const { event, direction = "vertical" } = defineProps<Props>();

type Slots = {
  forcedName?(props: { eventName: string }): HTMLElement;
  homeTeam?(props: { teamName: string; featured: boolean }): HTMLElement;
  awayTeam?(props: { teamName: string; featured: boolean }): HTMLElement;
};

defineSlots<Slots>();

const {
  hasParticipants,
  homeTeam,
  awayTeam,
  isHomeTeamFeatured,
  isAwayTeamFeatured,
} = useEventDetails(() => event);
</script>

<template>
  <div v-if="!event.forceEventName && hasParticipants">
    <slot
      name="homeTeam"
      :team-name="homeTeam?.name ?? ''"
      :featured="isHomeTeamFeatured"
    >
      <p
        :class="{
          'font-semibold': isHomeTeamFeatured,
          inline: direction === 'horizontal',
        }"
      >
        {{ homeTeam?.name ?? "" }}
      </p>
    </slot>

    <span v-if="divider && homeTeam && awayTeam">{{ ` - ` }}</span>

    <template v-if="awayTeam">
      <slot
        name="awayTeam"
        :team-name="awayTeam.name ?? ''"
        :featured="isAwayTeamFeatured"
      >
        <p
          :class="{
            'font-semibold': isAwayTeamFeatured,
            inline: direction === 'horizontal',
          }"
        >
          {{ awayTeam.name }}
        </p>
      </slot>
    </template>
  </div>
  <div v-else>
    <slot
      name="forcedName"
      :event-name="event.name"
    >
      <p class="font-bold">
        {{ event.name }}
      </p>
    </slot>
  </div>
</template>
